import { Component, computed, input } from '@angular/core';
import { TimePipe } from '@app/pipes/time.pipe';
import { ScheduleModel } from '@app/reducers/orm/schedule/schedule.model';
import { UserColorBgPipe } from '@sb/shared/theme';

/** Same fallback the schedule item hosts use when a shift carries no colour. */
const DEFAULT_SHIFT_COLOR = '#2399e4';

/**
 * Mirrors a schedule shift: colour bar plus a wash of the same colour. Shared by the
 * three find-cover surfaces, which differ only in what they put on the trailing edge.
 */
@Component({
  selector: 'find-cover-shift-row',
  templateUrl: './find-cover-shift-row.component.html',
  imports: [TimePipe, UserColorBgPipe],
})
export class FindCoverShiftRowComponent {
  shift = input.required<ScheduleModel>();

  color = computed(() => {
    const shift = this.shift();

    return shift.Shift?.color ?? shift.color ?? DEFAULT_SHIFT_COLOR;
  });
}
